export const VERIFICATION_MODE = {
  STANDARD: 'STANDARD',
  PASSWORD_UPGRADE: 'PASSWORD_UPGRADE',
  CREDENTIAL_MIGRATION: 'CREDENTIAL_MIGRATION'
}

// Identity-verification field-visibility matrix for the three verification modes.
export function getVisibleFields (mode) {
  switch (mode) {
    case VERIFICATION_MODE.STANDARD:
      return {
        identifierEditable: false,
        showCurrentPassword: true,
        showNewPassword: false,
        showNewPasswordConfirm: false,
        showOtc: true
      }
    case VERIFICATION_MODE.PASSWORD_UPGRADE:
      return {
        identifierEditable: true,
        showCurrentPassword: true,
        showNewPassword: true,
        showNewPasswordConfirm: true,
        showOtc: true
      }
    case VERIFICATION_MODE.CREDENTIAL_MIGRATION:
      return {
        identifierEditable: true,
        showCurrentPassword: true,
        showNewPassword: false,
        showNewPasswordConfirm: false,
        showOtc: true
      }
    default:
      throw new Error(`fieldVisibility.getVisibleFields: unknown mode "${mode}"`)
  }
}
